import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { Site } from './site';

export class SiteFile extends BaseModel {
  static SiteFileProperties: (
    | {
        property: keyof SiteFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SiteFile;
        type: 'alias';
      }
    | {
        property: keyof SiteFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'SiteId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Site', model: 'Site', type: 'association' },
    { property: 'File', model: 'File', type: 'association' }
  ];

  static {
    SiteFile.SiteFileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        SiteFile.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        SiteFile.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        SiteFile.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(SiteFileObject: Partial<SiteFile>) {
    super();

    SiteFile.SiteFileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = SiteFileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  SiteId?: number;
  FileId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Site?: Site;
  File?: File;
}
